import React from 'react';
import { CheckCircle, XCircle, AlertCircle, X } from 'lucide-react';
import { useApp } from '../../context/AppContext';

const iconMap = {
  success: <CheckCircle className="w-5 h-5 text-green-500" />,
  error: <XCircle className="w-5 h-5 text-red-500" />,
  warning: <AlertCircle className="w-5 h-5 text-yellow-500" />,
};

const bgMap = {
  success: 'border-green-200 dark:border-green-700',
  error: 'border-red-200 dark:border-red-700',
  warning: 'border-yellow-200 dark:border-yellow-700',
};

export const ToastContainer = () => {
  const { toasts, removeToast } = useApp();

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 bg-white dark:bg-gray-800 border ${bgMap[toast.type] || bgMap.success} rounded-lg shadow-lg px-4 py-3 min-w-[280px] animate-slide-in`}
        >
          {iconMap[toast.type] || iconMap.success}
          <span className="text-sm text-gray-800 dark:text-gray-200 flex-1">{toast.message}</span>
          <button onClick={() => removeToast(toast.id)} className="text-gray-400 hover:text-gray-600">
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
